'use strict';

const { h } = require('phy');

const CouponCardAction = require('./coupon-card-action');
const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');
const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');
const OfferExpiry = require('../../shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../shared/views/offer/offer-view-terms');

function CouponCard({ coupon, routes }) {
  const ExclusiveElement =
    coupon.isExclusive &&
    OfferExclusive({ className: 'coupon-card-exclusive' });
  const ExpiryElement = OfferExpiry({
    className: 'coupon-card-expiry',
    expires: coupon.expiryDateTime,
  });

  return h('.coupon-card', [
    h('.coupon-card-logo', [
      MerchantLogoImage({
        className: 'coupon-card-image',
        alt: `${coupon.merchant.merchantName} - ${coupon.calloutValue}`,
        data: coupon && coupon.merchant && coupon.merchant.merchantMedia,
        size: ['w_120,h_120'],
      }),
      ExclusiveElement,
    ]),
    h('.coupon-card-content', [
      h('p.coupon-card-title', coupon.offerTitle),
      ExpiryElement,
      OfferViewTerms({
        routes,
        offerId: coupon.offerId,
        className: 'coupon-card-terms',
      }),
      OfferRedemptionText({
        className: 'coupon-card-type',
        type: coupon.offerType,
      }),
    ]),
    CouponCardAction({
      offerId: coupon.offerId,
      routes,
    }),
  ]);
}

module.exports = CouponCard;
